export const APP_STORE_URL = 'https://apps.apple.com/app/apple-store/id6755904064?pt=128149160&ct=WebsiteLink&mt=8';

export function appStoreUrlForLocation(location = 'site') {
  const campaignLocation = String(location || 'site')
    .trim()
    .replace(/[^a-zA-Z0-9]+/g, ' ')
    .split(' ')
    .filter(Boolean)
    .map((part) => `${part.charAt(0).toUpperCase()}${part.slice(1)}`)
    .join('')
    .slice(0, 28);
  const url = new URL(APP_STORE_URL);

  url.searchParams.set('ct', `Website${campaignLocation || 'Site'}`);
  return url.toString();
}

const APP_ID = '6755904064';
const PROMO_BASE_URL = 'https://promo.bhol.app';
const redeemUrlForCode = (code) => `https://apps.apple.com/redeem/?ctx=offercodes&id=${APP_ID}&code=${code}`;
const UGC_FAMILY_REDEEM_URL = `https://apps.apple.com/redeem?ctx=offercodes&id=${APP_ID}&code=UGCFAM`;

export const PROMO_OFFERS = {
  oneMonth: {
    id: 'one-month',
    code: 'LOPPA',
    offerLabel: '1 month free trial',
    seoTitle: 'Bhol Promo Code - 1 Month Trial',
    seoDescription: 'Private Bhol promo: claim a one-month App Store trial code for Bhol.',
    canonicalUrl: `${PROMO_BASE_URL}/`,
    ogImage: `${PROMO_BASE_URL}/promo-trial-share.png`,
    headline: 'One month of Bhol, on us.',
    subhead: 'Start a one-month trial and see how Bhol fits your family conversations.',
    ctaLabel: 'Continue to 1 month trial',
    redeemUrl: redeemUrlForCode('LOPPA'),
    aliases: ['one-month', 'one-month-trial', '1-month', '1-month-trial', 'trial', 'loppa'],
  },
  oneYear: {
    id: '1year',
    code: 'UGCFAM',
    offerLabel: '1 year family invite',
    seoTitle: 'Bhol Promo Code - 1 Year Family Invite',
    seoDescription: 'Private Bhol promo: claim a one-year App Store offer code for Bhol.',
    canonicalUrl: `${PROMO_BASE_URL}/1year`,
    ogImage: `${PROMO_BASE_URL}/promo-trial-share.png`,
    headline: 'A year of Bhol for the family.',
    subhead: 'Claim a one-year invite and keep practicing the conversations that matter.',
    ctaLabel: 'Continue to 1 year offer',
    redeemUrl: UGC_FAMILY_REDEEM_URL,
    aliases: ['1year', '1-year', 'one-year', 'one-year-family', 'year', 'yearly', 'annual', '1yr', 'oneyear', 'family', 'ugcfam'],
  },
};

export const DEFAULT_PROMO_OFFER = PROMO_OFFERS.oneMonth;
export const PROMO_REDEEM_URL = DEFAULT_PROMO_OFFER.redeemUrl;

function normalizePromoOfferToken(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

const PROMO_OFFER_BY_ALIAS = Object.values(PROMO_OFFERS).reduce((offersByAlias, offer) => {
  [offer.id, offer.code, ...offer.aliases].forEach((alias) => {
    offersByAlias.set(normalizePromoOfferToken(alias), offer);
  });
  return offersByAlias;
}, new Map());

export function promoOfferForToken(value) {
  return PROMO_OFFER_BY_ALIAS.get(normalizePromoOfferToken(value)) || null;
}

export function promoOfferFromLocation({ pathname = '/', search = '' } = {}) {
  const normalizedSearch = search && !search.startsWith('?') ? `?${search}` : search;
  const params = new URLSearchParams(normalizedSearch);
  const queryOffer = ['offer', 'promo', 'o', 'p', 'code']
    .map((name) => promoOfferForToken(params.get(name)))
    .find(Boolean);

  if (queryOffer) {
    return queryOffer;
  }

  const pathParts = String(pathname || '/')
    .split('/')
    .map(normalizePromoOfferToken)
    .filter(Boolean);
  const promoPathParts = pathParts[0] === 'promo' ? pathParts.slice(1) : pathParts;

  return promoOfferForToken(promoPathParts[0]) || DEFAULT_PROMO_OFFER;
}
